var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31,8v22c0,0.55-0.45,1-1,1H2c-0.55,0-1-0.45-1-1V2c0-0.55,0.45-1,1-1h22c0.27,0,0.52,0.11,0.71,0.29l6,6    C30.89,7.48,31,7.73,31,8z",
    fill: "#48B1DD"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,1.58V10c0,0.55-0.45,1-1,1H8c-0.55,0-1-0.45-1-1V1h17c0.27,0,0.52,0.11,0.71,0.29L25,1.58z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25,20v11H7V20c0-0.55,0.45-1,1-1h16C24.55,19,25,19.45,25,20z",
    fill: "#96CEE5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20,1v5c0,0.55-0.45,1-1,1s-1-0.45-1-1V1H20z",
    fill: "#4391B2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M19,26h-6c-0.5527,0-1-0.4478-1-1s0.4473-1,1-1h6c0.5527,0,1,0.4478,1,1S19.5527,26,19,26z",
    fill: "#4391B2"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSave);
export default __webpack_public_path__ + "static/media/icon_save.e6d57a86d132bae5373dd45f8267a1b3.svg";
export { ForwardRef as ReactComponent };